export var CollectorId;
(function (CollectorId) {
    CollectorId["camera"] = "camera";
    CollectorId["screen"] = "screen";
    CollectorId["navigation"] = "navigation";
})(CollectorId || (CollectorId = {}));
export var PlasmState;
(function (PlasmState) {
    PlasmState["notready"] = "notready";
    PlasmState["started"] = "started";
    PlasmState["stopped"] = "stopped";
})(PlasmState || (PlasmState = {}));
export var ScreenSelectedArea;
(function (ScreenSelectedArea) {
    ScreenSelectedArea["monitor"] = "monitor";
    ScreenSelectedArea["application"] = "application";
    ScreenSelectedArea["tab"] = "tab";
    ScreenSelectedArea["unknown"] = "unknown";
})(ScreenSelectedArea || (ScreenSelectedArea = {}));
export var BehaviorType;
(function (BehaviorType) {
    BehaviorType["click"] = "click";
    BehaviorType["dblclick"] = "dblclick";
    BehaviorType["copy"] = "copy";
    BehaviorType["cut"] = "cut";
    BehaviorType["paste"] = "paste";
    BehaviorType["load"] = "load";
    BehaviorType["online"] = "online";
    BehaviorType["offline"] = "offline";
    BehaviorType["blur"] = "blur";
    BehaviorType["focus"] = "focus";
    BehaviorType["beforeunload"] = "beforeunload";
    BehaviorType["contextmenu"] = "contextmenu";
    BehaviorType["change"] = "change";
    BehaviorType["drag"] = "drag";
    BehaviorType["select"] = "select";
    BehaviorType["resize"] = "resize";
    BehaviorType["afterresize"] = "afterresize";
    BehaviorType["scroll"] = "scroll";
    BehaviorType["mouseout"] = "mouseout";
    BehaviorType["key"] = "key";
    BehaviorType["unfocus"] = "unfocus";
    BehaviorType["mousespeed"] = "mousespeed";
    BehaviorType["keystrokespeed"] = "keystrokespeed";
    BehaviorType["question_shown"] = "question_shown";
})(BehaviorType || (BehaviorType = {}));
